const publicPath = process.env.NODE_ENV == "development" ? '/api' : "https://www.griacesc.jp";
const asset = (path = '') => publicPath + path;
const imagePlaceholder = (size = 'square') => (size == 'square') ? '/assets/img/placeholder.jpg' : '/assets/img/placeholder-rect.jpg';

export default {
    publicPath, asset, imagePlaceholder
}